// src/App.js
import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { CompetitionProvider } from './contexts/CompetitionContext';
import Header from './shared/components/Header';
import { routes } from './routes';

const App = () => {
    return (
        <HashRouter>
            <ThemeProvider>
                <AuthProvider>
                    <CompetitionProvider>
                        <Header />
                        <Routes>
                            {routes.map((route, index) => (
                                <Route
                                    key={index}
                                    path={route.path}
                                    element={route.element}
                                />
                            ))}
                        </Routes>
                    </CompetitionProvider>
                </AuthProvider>
            </ThemeProvider>
        </HashRouter>
    );
};

export default App;
